import { MatchHeaderParams } from '../../http/RestResource';

export class MatchAuthorizationParams extends MatchHeaderParams {
	constructor(headerFields: Array<string> = []) {
		super(['authorization'].concat(headerFields));
	}
}
